import { combineReducers } from 'redux';

import userReducer from './User';
import databaseReducer from './Database';
import sharedStateReducer from './SharedState';

export default combineReducers({
  userReducer,
  databaseReducer,
  sharedStateReducer
});